// Mayasurts: thin progress bar under horizontal product carousels, so it is obvious they scroll.
class MayaScrollProgress extends HTMLElement {
  connectedCallback() {
    this.scroller = this.parentElement?.querySelector('slideshow-slides');
    if (!this.scroller) return;
    this.thumb = this.querySelector('span');
    this.update = this.update.bind(this);
    this.scroller.addEventListener('scroll', this.update, { passive: true });
    this.ro = new ResizeObserver(this.update);
    this.ro.observe(this.scroller);
    this.update();
  }

  disconnectedCallback() {
    this.scroller?.removeEventListener('scroll', this.update);
    this.ro?.disconnect();
  }

  update() {
    const { scrollWidth, clientWidth, scrollLeft } = this.scroller;
    const max = scrollWidth - clientWidth;
    this.hidden = max <= 2;
    if (this.hidden) return;
    const ratio = clientWidth / scrollWidth; // visible part = thumb width
    const progress = Math.min(1, Math.max(0, Math.abs(scrollLeft) / max));
    this.thumb.style.width = `${ratio * 100}%`;
    this.thumb.style.transform = `translateX(${progress * (1 / ratio - 1) * 100}%)`;
  }
}

if (!customElements.get('maya-scroll-progress')) customElements.define('maya-scroll-progress', MayaScrollProgress);
